// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__f3po3","description":"styles_description__J8RsN","title":"styles_title__6pCnm"};